import axios from 'axios'

const fetchWorkflows = async filter => {
  let url = `/api/v1/workflows`
  if (filter) {
    url = url + filter + '&projection=withMetrics'
  }
  return await axios.get(url)
}

const deleteWorkflow = async hexId => {
  await axios.delete(`/api/v1/workflows/${hexId}`)
}

export default {
  fetchWorkflows,
  deleteWorkflow
}
